/**
 * Laws the Action plan draws from each building's /codes/ (laws plan §2 Allowlist). Each law's evidence
 * commit adds its entry; ll97, ll88 and ll33 never enter (RT6). Steps: components/portal/lawSteps.ts.
 */
// The rail's LL33 step words. Not ontoModel's YOU: Ontology/stages.ts imports this module and reads it at load.
import { WHO_LABEL } from "@/components/portal/ll33/ll33Status";
import { LANE_DOB, LANE_HPD } from "@/components/portal/useActionPlanFeed";

/** A law row's ActionItem kind (laws plan §1). */
export const LAW_KIND = "filing";

/** The laws' name (laws plan §4 G12): the Ontology block and the staff not-read line. */
export const LAWS_LABEL = "Local laws";

/** The Codes ?code= id. */
export const BEDBUG_REPORT = "bedbug_report";
export const ELEVATOR_CAT1 = "elevator_cat1";
export const FISP = "fisp";

const INSPECTOR_FILES = "Inspector files";
const QEWI_FILES = "QEWI files";

export const LAW_CODES = {
  // AC 27-2018.2; HPD's filing window and period are the server's filing_cycle.
  [BEDBUG_REPORT]: {
    tag: "Bed bugs",
    agency: LANE_HPD,
    /** Who does each lawSteps step; the law panel draws it. Step 1's is the row's whoActs. */
    stepWho: [WHO_LABEL.you, WHO_LABEL.you, WHO_LABEL.you],
    lead: "The report covers Nov 1 to Oct 31.",
  },
  // 1 RCNY 103-02(c)(5)(i). No money line: the tile is unpriced (laws plan §3a 15).
  [ELEVATOR_CAT1]: {
    tag: "CAT1",
    agency: LANE_DOB,
    // 103-02(e), (i)(3): the fix and its affirmation are the owner's.
    stepWho: [INSPECTOR_FILES, INSPECTOR_FILES, WHO_LABEL.you],
    lead: "The test year runs Jan 1 to Dec 31.",
  },
  // AC 28-302.2; 1 RCNY 103-04(c)(2)(ii): the owner retains the QEWI, who files (103-04(a)). No money line (§3 RT3).
  [FISP]: {
    tag: "LL11",
    agency: LANE_DOB,
    stepWho: [WHO_LABEL.you, QEWI_FILES, WHO_LABEL.you],
    // Related's 2 bodies: 10C opens 2027-02-21, SWARMP; useLawRows.test pins it. 103-04(a), (c)(6)(iii) (§3a 17).
    lead: "The 10C window opens Sun Feb 21, 2027. Repair the SWARMP items before the 10C inspection, or they file as unsafe.",
  },
} as const;

export type LawCode = keyof typeof LAW_CODES;
export const LAW_IDS = Object.keys(LAW_CODES) as LawCode[];

export const lawKey = (code: LawCode, buildingId: string): string =>
  `law:${code}:${buildingId}`;

/** The law a law row's key names. */
export const lawOfKey = (key: string): LawCode | undefined =>
  LAW_IDS.find((c) => key.startsWith(lawKey(c, "")));

/** The law a deck lane (its tag) names. */
export const lawOfLane = (lane: string): LawCode | undefined =>
  LAW_IDS.find((c) => LAW_CODES[c].tag === lane);
